import { Cursor04Icon } from '@/components/icons/Cursor04Icon';
import { DispositionsFormSplitScreenRightPanel } from '@/modules/dispositiveProvisions/DispositiveProvisionsFormV2/components/panels/DispositionsFormSplitScreenRightPanel';
import { COLORS } from '@/styles/tokens/colors';

export function InitialTileSelectionPanel() {
  return (
    <DispositionsFormSplitScreenRightPanel
      dataTestId="initialTileSelectionPanel"
      IconElement={<Cursor04Icon size={48} color={COLORS.GRAY['200']} />}
      title="Add dispositions"
      subtitle="Select a tile from the diagram on the left to add and view dispositions."
    />
  );
}
